import { FieldGroup } from "@repo/ui/ui/field";

import type { DatasourceForm } from "./datasource-new.types";

/** Databricks credential fields. */
export const DatabricksFields = ({ form }: { form: DatasourceForm }) => (
  <FieldGroup>
    <form.AppField name="host">
      {(field) => (
        <field.TextField
          label="Host"
          placeholder="adb-1234567890.1.azuredatabricks.net"
        />
      )}
    </form.AppField>

    <form.AppField name="path">
      {(field) => (
        <field.TextField
          label="HTTP path"
          placeholder="/sql/1.0/warehouses/abc123"
        />
      )}
    </form.AppField>

    <form.AppField name="token">
      {(field) => (
        <field.PasswordField label="Access token" placeholder="dapi••••••••" />
      )}
    </form.AppField>

    <form.AppField name="catalog">
      {(field) => <field.TextField label="Catalog" placeholder="main" />}
    </form.AppField>
  </FieldGroup>
);
